import React, { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link } from 'react-router-dom'
import { Container, Title, IconWrapper } from './styles'

const Helper = ({
  icon: Icon,
  title,
  to,
  onClick
}) => {

  const [isOpen, setIsOpen] = useState(false)

  const props = !!to
    ? { to, as: Link }
    : { onClick, role: 'button'}

  const toggleOpen = () => setIsOpen(prev => !prev)

  const handleMouseEnter = () => {
    if (isMobile) return
    setIsOpen(true)
  }

  const handleMouseLeave = () => {
    if (isMobile) return
    setIsOpen(false)
  }

  useEffect(() => {
    if (!isOpen) return

    const handleClose = () => setIsOpen(false)

    window.addEventListener('click', handleClose)
    return () => window.removeEventListener('click', handleClose)
  }, [isOpen])

  return (
    <Container
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      $isOpen={isOpen}
    >
      <IconWrapper onClick={toggleOpen}>
        <Icon />
      </IconWrapper>
      <Title {...props}>{title}</Title>
    </Container>
  )
}

export default Helper